import React, { useEffect, useRef, useState } from 'react';

// Spaces and commas delimit srcset candidates, so they must be escaped
// (several filenames are like "A7408254 (1).jpg").
const esc = (url) => url.replace(/ /g, '%20').replace(/,/g, '%2C');

const srcSetFor = (image, hiRes) => {
  const w = image.width;
  const entries = [];
  if (image.webp800) entries.push(`${esc(image.webp800)} ${Math.min(800, w)}w`);
  if (image.webp1600 && w > 800) entries.push(`${esc(image.webp1600)} ${Math.min(1600, w)}w`);
  if (hiRes && image.webp && w > 1600) entries.push(`${esc(image.webp)} ${w}w`);
  if (!entries.length && image.webp) entries.push(`${esc(image.webp)} ${w}w`);
  return entries.length ? entries.join(', ') : null;
};

/**
 * Photo with WebP srcset, its average colour as placeholder, and a soft
 * fade/settle once decoded. `fit="contain"` letterboxes instead of cropping.
 */
const Img = ({
  image,
  alt,
  sizes = '100vw',
  eager = false,
  hiRes = false,
  fit = 'cover',
  className = '',
  style,
}) => {
  const ref = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const el = ref.current;
    setLoaded(Boolean(el && el.complete && el.naturalWidth));
  }, [image.src]);

  const srcSet = srcSetFor(image, hiRes);

  return (
    <span
      className={`img img--${fit}${loaded ? ' is-loaded' : ''} ${className}`}
      style={{ '--ph': image.color, ...style }}
    >
      <picture>
        {srcSet && <source type="image/webp" srcSet={srcSet} sizes={sizes} />}
        <img
          ref={ref}
          src={image.src}
          alt={alt}
          width={image.width}
          height={image.height}
          loading={eager ? 'eager' : 'lazy'}
          decoding="async"
          fetchpriority={eager ? 'high' : undefined}
          draggable={false}
          onLoad={() => setLoaded(true)}
        />
      </picture>
    </span>
  );
};

export default Img;
